<div class="col-12 text-center">
    <img class="img-fluid" style="max-height: 300px; margin: 0 auto;" src="/content/r-loading.gif"/>
</div>